import SelectedSalesAccountReducer
    from "PlattixSalesUI/core/slices/SalesAccountReducer";



export const reducers = {
    selectedSalesAccount: SelectedSalesAccountReducer
}

export default reducers;